import { render, staticRenderFns } from "./VerticalCard.vue?vue&type=template&id=8958c0be&"
import script from "./VerticalCard.vue?vue&type=script&lang=js&"
export * from "./VerticalCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports